
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/6b84a11e410079b56c6291a27cbf72c2/f6705f108820539b719f4aab61e9054b.jpeg" 
                alt="Henatos Limited Logo" 
                className="h-12 w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-2xl font-bold text-blue-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Henatos
                </h1>
                <p className="text-xs text-gray-600">Africa's Trusted Partner</p>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Home</a>
            <a href="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">About</a>
            <a href="/products" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Products</a>
            <a href="/suppliers" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Suppliers</a>
            <a href="/buyers" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Buyers</a>
            <a href="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Contact</a>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button href="/contact" variant="primary">
              Get Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 focus:outline-none"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Home</a>
              <a href="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">About</a>
              <a href="/products" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Products</a>
              <a href="/suppliers" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Suppliers</a>
              <a href="/buyers" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Buyers</a>
              <a href="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">Contact</a>
              <div className="pt-2">
                <Button href="/contact" variant="primary" size="sm">
                  Get Quote
                </Button>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
